/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
/* eslint-disable angular/document-service */
angular.module('tgaAdmin')
  .controller('InstructorSessionsController', [
    '$scope', '$state', '$location', '$filter', '$timeout', '$window', 'gameService', 'instructorService',
    'reportService', 'userService', 'modalService', 'game', 'tzService', '$log',
    function (
      $scope, $state, $location, $filter, $timeout, $window, gameService, instructorService,
      reportService, userService, modalService, game, tzService, $log,
    ) {
      $scope.showBack = false;

      $scope.data = {
        gameId: $state.params.game_id || null,
        isAdmin: userService.checkUserType(['admin', 'super_admin']),
        currectUser: userService.getCurrentUser,
      };

      $scope.viewmodel = {
        session_groups: [],
        game,
      };

      $scope.initialize = function () {
        $scope.loading = true;

        if (game.game_mode === 'standard') {
          $window.history.back();
          return;
        }

        $scope.title = `<span class="text-muted">Instructor / ${game.name} / </span> Sessions`;

        instructorService.getSessionGroups($scope.data.gameId).then((data) => {
          $scope.viewmodel.session_groups = data;
          $scope.loading = false;
        });
      };

      $scope.actions = {
        canExport() {
          if (game.game_type !== 'flash') {
            return false;
          }

          return $scope.viewmodel.session_groups.filter((item) => item.report === true).length > 0;
        },
        // eslint-disable-next-line consistent-return
        exportReport() {
          if (!$scope.actions.canExport()) {
            return false;
          }

          $scope.exporting = true;

          const workbook = new ExcelJS.Workbook();
          workbook.creator = 'The Training Arcade';

          /// /////////////
          // Overview
          const worksheet = workbook.addWorksheet('Overview');

          const header = [
            { header: 'Test Name', key: 'test_name', width: 12 },
            { header: 'Moderator Name', key: 'created_by_name', width: 12 },
            { header: 'Session Name', key: 'session_name', width: 12 },
            { header: 'Session #', key: 'session_id', width: 12 },
            { header: 'Session Date', key: 'date_created', width: 12 },
            { header: 'Session Start Time', key: 'time_start', width: 12 },
            { header: 'Session End Time', key: 'time_end', width: 12 },
            { header: 'Player', key: 'player', width: 12 },
          ];

          if ($scope.viewmodel.game.registration.required === true) {
            for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
              if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                header.push({
                  header: $scope.viewmodel.game.registration.fields[i].label,
                  key: $scope.viewmodel.game.registration.fields[i].key,
                });
              }
            }

            for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
              if ($scope.viewmodel.game.registration.custom_fields[i].condition !== null) {
                header.push({
                  header: $scope.viewmodel.game.registration.custom_fields[i].label,
                  key: $scope.viewmodel.game.registration.custom_fields[i].key,
                });
              }
            }
          }

          header.push({ header: 'Total Clues Served', key: 'total_questions', width: 12 });
          header.push({ header: 'Total Clues Correct', key: 'total_correct', width: 12 });
          header.push({ header: 'Total Clues Incorrect', key: 'total_incorrect', width: 12 });
          header.push({ header: 'Total Clues Not Answered', key: 'total_missed', width: 12 });
          header.push({ header: 'Total Time to Answer Correct Clues', key: 'total_answer_time', width: 12 });
          header.push({ header: 'Clue #', key: 'question_num', width: 12 });
          header.push({ header: 'Category', key: 'category', width: 12 });
          header.push({ header: 'Clue Text', key: 'text', width: 12 });
          header.push({ header: 'Correct Answer In Full', key: 'exact_answer', width: 12 });
          header.push({ header: 'Acceptable Response(s)', key: 'alt_answers', width: 12 });
          header.push({ header: 'Test Taker Response', key: 'answer_text', width: 12 });
          header.push({ header: 'Correct', key: 'correct', width: 12 });
          header.push({ header: 'Incorrect', key: 'incorrect', width: 12 });
          header.push({ header: 'Original Value', key: 'original_correct', width: 12 });
          header.push({ header: 'Override Date', key: 'date_updated', width: 12 });
          header.push({ header: 'Override By', key: 'updated_by', width: 12 });

          worksheet.columns = header;

          worksheet.getRow(1).font = { bold: true };

          worksheet.getColumn(5).numFmt = 'm/d/yyyy';
          worksheet.getColumn(6).numFmt = '[h]:mm:ss';
          worksheet.getColumn(7).numFmt = '[h]:mm:ss';
          worksheet.getColumn(header.length - 11).numFmt = '[h]:mm:ss';

          worksheet.views = [
            { state: 'frozen', ySplit: 1 },
          ];

          worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
          };

          const promises = [];
          let row = 2;
          const collapseRows = [];

          for (let s = 0; s < $scope.viewmodel.session_groups.length; s++) {
            if (!$scope.viewmodel.session_groups[s].report) {
              // eslint-disable-next-line no-continue
              continue;
            }

            const { session_group_id } = $scope.viewmodel.session_groups[s];

            const promise = instructorService.getSessionGroup(
              $scope.data.gameId,
              session_group_id,
            ).then(
              // eslint-disable-next-line no-loop-func
              (session_group) => instructorService.getPlayers({ session_group_id: session_group.session_group_id }).then(
                (players) => {
                  for (let j = 0; j < players.length; j++) {
                    const player = players[j];
                    const duration = $filter('formatDuration')(player.result.total_correct_time).split(':');

                    let rowData = {
                      test_name: $scope.viewmodel.game.name,
                      created_by_name: session_group.created_by_name,
                      session_name: session_group.name,
                      session_id: session_group.session_group_id,
                      date_created: { formula: `DATEVALUE("${tzService.parseFormatUserDate(session_group.date_created, 'YYYY-MM-DD')}")` },
                      time_start: { formula: `TIMEVALUE("${tzService.parseFormatUserDate(session_group.date_created, 'HH:mm:ss')}")` },
                      time_end: { formula: `TIMEVALUE("${tzService.parseFormatUserDate(session_group.date_ended, 'HH:mm:ss')}")` },
                      player: player.display_name,
                      total_questions: player.result.total,
                      total_correct: player.result.total_correct,
                      total_incorrect: player.result.total - player.result.total_correct,
                      total_missed: player.result.total - player.result.total_answered,
                      total_answer_time: { formula: `TIME(${duration[0]},${duration[1]},${duration[2]}) + INT(${duration[0]}/ 24)` },
                    };

                    if ($scope.viewmodel.game.registration.required === true) {
                      for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                        if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                          // eslint-disable-next-line max-len
                          rowData[$scope.viewmodel.game.registration.fields[i].key] = player[$scope.viewmodel.game.registration.fields[i].key];
                        }
                      }

                      for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
                        if ($scope.viewmodel.game.registration.custom_fields[i].condition !== null) {
                          // eslint-disable-next-line max-len
                          rowData[$scope.viewmodel.game.registration.custom_fields[i].key] = player.custom_fields[$scope.viewmodel.game.registration.custom_fields[i].key] ? player.custom_fields[$scope.viewmodel.game.registration.custom_fields[i].key].text : null;
                        }
                      }
                    }

                    worksheet.addRow(rowData);
                    row++;

                    if (player.questions.length) {
                      collapseRows.push({ start: row, end: row + player.questions.length });
                    }

                    for (let k = 0; k < player.questions.length; k++) {
                      const question = player.questions[k];
                      rowData = {
                        question_num: k + 1,
                        category: question.question_group ? question.question_group.name : null,
                        text: $filter('htmlToPlaintext')(question.text),
                        exact_answer: question.possible_answers[0].text,
                        alt_answers: $filter('getProperty')($filter('filter')(question.possible_answers, { match_type: '' }), 'text'),
                        answer_text: $filter('getProperty')(question.answers, 'text'),
                        correct: question.correct ? 1 : 0,
                        incorrect: question.correct ? 0 : 1,
                        // eslint-disable-next-line no-nested-ternary
                        original_correct: question.date_updated ? (question.original_correct ? 'Correct' : 'Incorrect') : null,
                        date_updated: tzService.parseFormatUserDate(question.date_updated, 'YYYY-MM-DD HH:mm:ss'),
                        updated_by: question.updated_by,
                      };

                      worksheet.addRow(rowData);
                      row++;
                    }
                  }

                  collapseRows.forEach((collapseRow) => {
                    for (let i = collapseRow.start; i < collapseRow.end; i++) {
                      worksheet.getRow(i).outlineLevel = 1;
                    }
                  });
                },
              ),
            );

            promises.push(promise);
          }

          Promise.all(promises).then(() => {
            // save workbook to disk
            workbook.xlsx.writeBuffer({ base64: true }).then((xls64) => {
              // build anchor tag and attach file (works in chrome)
              const a = document.createElement('a');
              const data = new Blob([xls64], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

              const url = URL.createObjectURL(data);
              a.href = url;
              a.download = reportService.generateReportFilename(
                `${$scope.viewmodel.game.name} Stats`,
                null,
                null,
                'xlsx',
              );

              document.body.appendChild(a);
              a.click();
              setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }, 0);
            }).catch((error) => {
              $log.log(error.message);
            });

            $timeout(() => {
              $scope.exporting = false;
            });
          });
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
